module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "dedication"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("dedication")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dedicated to all of the people who suffer with debilitating gut issues on a daily basis. And to my dear Dad (“Doc”) and my late Mom, whom I miss dearly. I have learned so much from them, and continue to learn the power of human compassion from my Dad. I love you both."), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a307caa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0